import config from '../../config/config';

import postRequest from './base/post';

export default {
  /**
   * Super admin auth login function
   * @param data
   * @param onUploadProgress Optional callback for tracking upload progress
   */
  login: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/super-admin/v1/auth/login`, data);
  },
  /**
   * Super admin auth login function
   * @param data
   * @param onUploadProgress Optional callback for tracking upload progress
   */
  accessFacilityPortal: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/super-admin/v1/auth/access-facility-portal`, data);
  },
  /**
   * super admin auth login function
   * @param data 
   * @returns 
   */
  accessUtilityPortal: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/super-admin/v1/auth/access-utility-portal`, data);
  },
  /**
   * Super admin forgot password function
   * @param data
   * @param onUploadProgress Optional callback for tracking upload progress
   */
  forgotPassword: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/super-admin/v1/auth/forgot-password`, data);
  },
  /**
   * Consumer delete function
   * @param data
   * @param onUploadProgress Optional callback for tracking upload progress
   */
  consumerDelete: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/end-consumer/v1/auth/delete-user-account`, data);
  },
  /**
   * Consumer delete verification otp function
   * @param data
   * @param onUploadProgress Optional callback for tracking upload progress
   */
  consumerDeleteVerificationOTP: (data: any = {}): Promise<any> => {
    return postRequest(`${config.accountApiUrl}api/end-consumer/v1/users/delete-user-request`, data);
  },
  /**
   * Verify reset password OTP API
   * @param data
   */
  resetPasswordOTPVerify: (data: any = {}): Promise<any> => {
    return postRequest(
      `${config.authApiUrl}api/super-admin/v1/auth/forgot-password-otp-verify`,
      data,
    );
  },
  /**
   * Verify reset password OTP API
   * @param data
   */
  createPassword: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/super-admin/v1/auth/reset-password`, data);
  },
  /**
   * Logout the auth function
   * @returns
   */
  logout: (data: any = {}): Promise<any> => {
    return postRequest(`${config.authApiUrl}api/super-admin/v1/auth/logout`, {
      ...data,
    });
  },
};
